import { useStore } from "vuex";
import { treeFind, treeToArray } from "@/utils/index";
import { saveOperRecord } from "@/api";
import { useRouter } from "vue-router";

export default function () {
  const store = useStore();
  const router = useRouter();
  // 清空缓存记录
  const removeRecord = () => {
    store.commit("SET_OPERATION_RECORD", null);
  };
  // 获取记录
  const getRecord = () => {
    return store.state.operationRecord;
  };
  // 创建记录
  const createRecord = (productName) => {
    removeRecord();
    store.commit("SET_OPERATION_RECORD", {
      productName,
      record: [],
    });
  };
  // 插入记录
  const insertRecord = (data) => {
    const record = getRecord();
    // 顶级问题处理 1. 存在不插入 2. 不存在插入
    if (data.parentId === "0") {
      if (record.record.find((item) => item.id === data.id)) return;
      record.record.push({
        id: data.id,
        parentId: data.parentId,
        children: [],
      });
      store.commit("SET_OPERATION_RECORD", record);
      return;
    }
    // 非顶级问题
    // 节点存在跳过
    const node = findNode(record.record, data.id);
    if (node) {
      node.children = [];
      store.commit("SET_OPERATION_RECORD", record);
      return;
    }
    // 不存在 查找出父节点 插入入父节点children
    const parentNode = findNode(record.record, data.parentId);
    if (!parentNode) return;
    parentNode.children.push({
      id: data.id,
      parentId: data.parentId,
      children: [],
    });
    store.commit("SET_OPERATION_RECORD", record);
  };
  // 查找点
  const findNode = (tree, id) => {
    return treeFind(tree, (item) => item.id === id);
  };
  /**
   * 保存节点
   * @param type 1 已解决 2 未解决
   * @param isBack 是否返回首页
   * @return {Promise<void>}
   */
  const saveNode = async (type, isBack = true) => {
    const record = getRecord();
    if (record) {
      await saveOperRecord({
        type,
        productName: record.productName,
        content: treeToArray(record.record).map((el) => {
          return {
            questionId: el.id,
            parentId: el.parentId,
            children: undefined,
          };
        }),
        siteCode: store.state.siteCode,
        siteName: "",
      });
    }
    if (isBack) {
      await router.replace(`/product/${store.state.siteCode}`);
    }
  };
  return {
    getRecord,
    createRecord,
    removeRecord,
    insertRecord,
    saveNode,
  };
}
